export default __webpack_public_path__ + "static/media/2430.f40e4ffd.jpg";